import React from "react";

let NotFound = () => (
  <section className="App App--404">
    <div>
      It appears you're lost. <a href="https://chat.kudi.ai">GET BACK</a>
    </div>
  </section>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/modules/NotFound.js